// Instead of using the NPM package which might have cross-origin issues,
// we'll use the script injection method recommended by Microsoft

export const initClarity = () => {
  try {
    // Only initialize if not already initialized
    if (!(window as any).clarity) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = `
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "qn7w1t6ik7");
      `;
      document.head.appendChild(script);
    }
    
    // Wait for Clarity to be available
    const waitForClarity = setInterval(() => {
      if ((window as any).clarity) {
        setupCustomEvents();
        clearInterval(waitForClarity);
      }
    }, 100);

    // Clear interval after 10 seconds to prevent infinite waiting
    setTimeout(() => clearInterval(waitForClarity), 10000);
  } catch (error) {
    console.error('Error initializing Clarity:', error);
  }
};

// Set up custom event tracking that integrates with our existing analytics
export const setupCustomEvents = () => {
  try {
    if (!(window as any).clarity) return;

    // Track page views
    (window as any).clarity("set", "page_view", window.location.pathname);

    // Track user type
    const userType = localStorage.getItem('user_type') || 'anonymous';
    (window as any).clarity("set", "user_type", userType);

    // Set up session tracking
    const sessionId = `session_${Date.now()}`;
    (window as any).clarity("identify", sessionId);

  } catch (error) {
    console.error('Error setting up Clarity custom events:', error);
  }
};

// Function to track custom events
export const trackClarityEvent = (eventName: string, metadata?: Record<string, string | string[]>) => {
  try {
    if (!(window as any).clarity) return;

    // Log event
    (window as any).clarity("event", eventName);
    
    // Add any metadata as tags
    if (metadata) {
      Object.entries(metadata).forEach(([key, value]) => {
        (window as any).clarity("set", key, value);
      });
    }
  } catch (error) {
    console.error('Error tracking Clarity event:', error);
  }
}; 